import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Store } from '@ngrx/store';
import { timer } from 'rxjs';

import { WarningAlert } from '@shared/alert/alert.actions';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PlatformUpdateService {
  constructor(
    private updates: SwUpdate,
    private store: Store,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  init() {
    this.updates.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        this.activateNewVersion();
      });

    // TODO(MOJAT-3673): get back to periodical check after auto-save feature is implemented
    // const twoHours = 2 * 60 * 60 * 1000;
    // const everyTwoHours$ = interval(twoHours);
    // TODO(MOJAT-3356): investigate and replace with appRef.isStable
    const initialCheck$ = timer(2500);

    initialCheck$.subscribe(() => {
      this.updates.checkForUpdate();
    });
  }

  activateNewVersion() {
    this.notifyUser();
    this.document.location.reload();
  }

  notifyUser() {
    this.store.dispatch(new WarningAlert('New version has been detected, refreshing the page...'));
  }
}
